import React from 'react';
import AttributesDialog from '../index';
import { RootStateOrAny, useSelector } from 'react-redux';
import { useFocusedAttribute } from '../hooks/useFocusedAttribute';
import { Modes } from '../../../redux/reducers/focusedAttributeReducer';
import ActionButton from './ViewSubmit';

const ViewAttributeDialog = () => {
  const { attribute, handleClose } = useFocusedAttribute(Modes.VIEW);
  
  const { brands } = useSelector((state: RootStateOrAny) => state.UserReducer);

  if (!attribute) return null;

  const brand = brands.find(({ brandCode }) => brandCode === attribute.brand);

  return (
    <AttributesDialog
      open
      onClose={handleClose}
      titleKey="attributes.modal.titleView"
      subtitleKey="attributes.modal.subtitleView"
      readOnly
      ActionButton={ActionButton}
      {...attribute}
      brand={brand}
    />
  );
};

export default ViewAttributeDialog;
